import React, { useEffect, useState } from "react";
import "./Formula.css";
import Accordion from "react-bootstrap/Accordion";
import { formula_accordian_img } from "assets/icons";
import useFullPageLoader from "common/UseFullPageLoader";
import { formulaFeedingListApi } from "services/formulaFeeding";
import { dateFormatWithTime } from "utils/dateFormat";
import moment from "moment";
import { firstWordCapital } from "utils/common";

const Formula = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [feedingList, setFeedingList] = useState([]);
  const [meta, setMeta] = useState({});
  const [selected, setSelected] = useState({});


  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await formulaFeedingListApi({ childId: _child, limit: 5000 });
      if (status === 200) {
        setFeedingList(data?.data);
        setMeta(data?.meta);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="formula_parent">
        {loader}
        <div className="formula_wraper">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="formula_lft_side">
                {/* abc */}

                <div className="input_formula_parent">
                  <div className="input_formula_wraper">
                    <div className="input_formula_txt">
                    <p>Avg Formula per day (This Week)</p>
                    <p className="litre">4.76ml</p>

                    </div>
                  </div>
                </div>

                <div className="formula_accordian">
                  <Accordion className="w-75">
                    <p className="formula_logo">Formula Logs</p>

                    {
                      feedingList.map((feeding, i) => {
                        return <Accordion.Item eventKey={i} key={i}>
                          <Accordion.Header>
                            <div className="formula_header">
                              <h6>{moment(feeding._id, "YYYY-MM-DD").format("LL")}</h6>
                            </div>
                          </Accordion.Header>

                          {
                            feeding?.documents?.map((ele, j) => {
                              return <Accordion.Body key={j} onClick={() => setSelected(ele)}>
                                <div className="formula_timimg_inside">
                                  <div className="formula_timing_wraper">
                                    <div className="formula_lft_img">
                                      <img src={formula_accordian_img} />
                                    </div>

                                    <div className="formula_rgt_content">
                                      <div className="formula_rgt_top">
                                        <div className="formula_timimg">
                                          <span>{dateFormatWithTime(ele?.createdAt)}</span>
                                          <div className="formula_liter">
                                            <b>{`${ele?.value} ${firstWordCapital(ele?.unit?.toLowerCase())}`}</b>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </Accordion.Body>
                            })
                          }
                        </Accordion.Item>
                      })
                    }

                  </Accordion>
                </div>
              </div>
            </div>

            {
              selected?._id
                ?
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="formula_right_side ">
                    <div className="doctor_visit_rgt">
                      <div className="doctor_visit_card">
                        <b>Amount</b>
                        <div className="date-time">
                          {`${selected?.value} ${firstWordCapital(selected?.unit?.toLowerCase())}`}
                          <br />
                        </div>
                        <b>Date & Time</b>
                        <div className="date-time">
                          {dateFormatWithTime(selected?.createdAt)}
                          <br />
                        </div>
                        <b>Note</b>
                        <div className="motorskilltracking-note">
                          <p>
                            {selected?.note}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                :
                null
            }

          </div>
        </div>
      </div>
    </>
  );
};

export default Formula;
